import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import editIcon from "../assets/images/edit.svg";
import viewIcon from "../assets/images/view.svg";
import downloadIcon from "../assets/images/download.svg";
import deleteIcon from "../assets/images/delete.svg";
import Sidebar from "../Common/Sidebar";
import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import CommonValues from "../Common/utils";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Loader from "../Common/Loader";
import { TabPanel, TabView } from "primereact/tabview";
import 'primeicons/primeicons.css';
import { ToggleButton } from "primereact/togglebutton";

export default function Documents() {
  const navigate = useNavigate();
  const toast: any = useRef("");
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showViewPopup, setShowViewPopup] = useState(false);
  const [selectedTag, setSelectedTag] = useState<any>(null);
  const [selectedType, setSelectedType] = useState<any>(null);
  const [selectedStatus, setSelectedStatus] = useState<any>(null);
  const [fileId, setFileId] = useState("");
  const [checked, setChecked] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const [documentViewType, setDocumentViewType] = useState("");
  const [loading, setLoading] = useState(false);
  const [documentId, setDocumentId] = useState(0);
  const [documentData, setDocumentData] = useState([]);
  const [documentName, setDocumentName] = useState("");
  const [documentDescription, setDocumentDescription] = useState("");
  const [documentByIdLoading, setDocumentByIdLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [documentNameError, setDocumentNameError] = useState("");
  const [documentTagError, setDocumentTagError] = useState("");
  const [documentTypeError, setDocumentTypeError] = useState("");
  const [documentStatusError, setDocumentStatusError] = useState("");
  const [callSummary, setCallSummary] = useState("");
  const [callerName, setCallerName] = useState("");
  const [callDuration, setCallDuration] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | string | null>(null);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState<{[key: number]: boolean}>({});
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [documentNameToDelete, setDocumentNameToDelete] = useState<string | null>(null);
  const [documentIdToDelete, setDocumentIdToDelete] = useState<number | null>(null);
  const [viewMode, setViewMode] = useState<'table' | 'explorer'>('table');
  // State to track which folder is currently open (null = show folders)
  const [currentFolder, setCurrentFolder] = useState<string | null>(null);
  const handleFolderClick = (type: string) => setCurrentFolder(type);
  const handleBackToFolders = () => setCurrentFolder(null);

  // Helper to get documents by type
  const getDocumentsByType = (type: string) => {
    return documentData.filter((doc: any) => doc.type === type);
  };

  const tagOptions = [
    { label: "Support", value: "Support" },
    { label: "Demo", value: "Demo" },
    { label: "Meeting", value: "Meeting" },
  ];
  const typeOptions = [
    { label: "Zoom", value: "zoom" },
    { label: "FireFlies", value: "fireflies" },
    { label: "Loom", value: "loom" },
    { label: "Other", value: "other" },
  ];
  const statusOptions =[
    { label : "Draft", value:"Draft"},
    { label : "Approved", value:"Approved"},
    { label : "Rejected", value:"Rejected"}
  ]
  useEffect(() => {
    getAllDocuments();
  }, []);
  const getAllDocuments = () => {
    var token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/documents/get`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    setLoading(true);
    axios(config)
      .then((response: any) => {
        setDocumentData(response.data.data);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status == 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            errorMessage = "Unknown error while loading the document details";
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: { errorMessage },
              life: 3000,
            });
          }
        } else {
          errorMessage = "Unknown error while loading the document details";
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: { errorMessage },
            life: 3000,
          });
        }
      });
  };
  const tagBodyTemplate = (rowdata: any) => {
    return (
      <span className="styled-badge text-muted me-1" style={{ backgroundColor: "#DDDEE1" }}>
        {rowdata.tag}
      </span>
    );
  };
  const actionBodyTemplate = (rowdata: any) => {
    return (
      <span>
        <img src={editIcon} title="Edit" alt="Edit" className="show-cursor" height={20} width={20} onClick={() => onEditButtonClick("Existing", rowdata)} />
        <img src={viewIcon} title="View" alt="View" className="show-cursor" height={20} width={20} onClick={() => onViewButtonClick(rowdata)} />
        {deleteLoading[rowdata.id] ? (
            <i className="pi pi-spinner pi-spin" style={{ fontSize: '1rem', marginLeft: '9px' }} />
         ) : (
           <img  src={deleteIcon} title="Delete" alt="Delete" className="show-cursor" height={20} width={20} 
           onClick={() => openDeleteDialog(rowdata.id ,rowdata.name)}
           />
         )}
      </span>
    );
  };
  const openDeleteDialog = (documentId: number,documentName: string) => {
  setDocumentIdToDelete(documentId);
  setDocumentNameToDelete(documentName);
  setDeleteDialogVisible(true);
};
const confirmDelete = async () => {
  if (documentIdToDelete !== null) {
    await onDeleteButtonClick(documentIdToDelete);
  }
  setDeleteDialogVisible(false);
  setDocumentIdToDelete(null);
};
const cancelDelete = () => {
  setDeleteDialogVisible(false);
  setDocumentIdToDelete(null);
};
  const viewDocumentactionTemplate = () => {
    return (
      <span>
        <img src={downloadIcon} alt="View" className="show-cursor" height={20} width={20} />
        <img src={editIcon} alt="Edit" className="show-cursor" height={20} width={20} />
        <img src={deleteIcon} alt="Delete" className="show-cursor" height={20} width={20} />
      </span>
    );
  };
  const statusBodyTemplate = () => {
    return <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />;
  };
  const onEditButtonClick = (type: any, rowdata: any) => {
    setDocumentViewType(type);
    setShowEditPopup(true);
    setDocumentName("");
    setDocumentDescription("");
    setSelectedTag(null);
    setSelectedType(null);
    setSelectedFile(null);
    setSelectedStatus(null);
    setDocumentNameError("");
    setDocumentTagError("");
    setDocumentTypeError("");
    setDocumentStatusError("");

    if (rowdata != null && type != "new") {
      setDocumentId(rowdata?.id);
      getDocumentById(rowdata.id)
    }
    else {
      setDocumentId(0);
      setSelectedStatus("Draft")
    }
  };
  const getDocumentById = (id: any) => {
    setDocumentByIdLoading(true);
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/documents/get/${id}`,
      headers: {}
    };

    axios.request(config)
      .then((response: any) => {
        setDocumentByIdLoading(false);
        setDocumentName(response.data.data.name)
        setDocumentDescription(response.data.data.description);
        setSelectedType(response.data.data.type);
        setSelectedTag(response.data.data.tag);
        setFileId(response.data.data.fileId);
        setSelectedStatus(response.data.data.status);
      })
      .catch((error: any) => {
        setDocumentByIdLoading(false);
        console.log(error);
        if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      });
  };
 const onViewButtonClick = async (rowdata: any) => {
  setSelectedType(rowdata.type);
  setShowViewPopup(true);
  setPreviewLoading(true);
  if (rowdata.type === "zoom") {
    getZoomDetailsByDocumentId(rowdata.id);
    setPreviewLoading(false);
  } else if (rowdata.type === "other") {
    try {
      const token = CommonValues.GetToken();
      const response = await fetch(
        `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/documents/download/${rowdata.fileId}`,
        {
          method: "GET",
          headers: {Authorization: `Bearer ${token}`,},
        }
      );
       if (!response.ok) {
         throw new Error("Failed to fetch document");
      }
       const blob = await response.blob();
       const fileURL = URL.createObjectURL(blob);
       setSelectedFile(fileURL);
     } catch (error : any) {
      if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
       setSelectedFile(null);
     } finally {
       setPreviewLoading(false);
     }
   }
 };
  
const onDeleteButtonClick = async (documentId: number) => {
  try {
     setDeleteLoading(prev => ({...prev, [documentId]: true}));
    const token = CommonValues.GetToken();
    const response = await axios.post(
      `${process.env.REACT_APP_Alexandria_API}/api/alexandria/document/delete/${documentId}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
     
  }catch (error : any) {
      if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
  }
  setTimeout(() => {
      setDeleteLoading(prev => ({ ...prev, [documentId]: false }));
    }, 1500);
   getAllDocuments();
};

  const getZoomDetailsByDocumentId = (documentid: any) => {
    setPreviewLoading(true);
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/zoom/documentid/${documentid}`,
      headers: {}
    };

    axios.request(config)
      .then((response: any) => {
        setPreviewLoading(false);
        setCallSummary(response.data.data.callSummary);
        setCallerName(response.data.data.callerName);
        setCallDuration(response.data.data.callDuration);
      })
      .catch((error: any) => {
        setPreviewLoading(false);
        if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      });
  }
  const onSaveButtonClick = () => {
    if (!validate()) return;
    setIsLoading(true); 
    const formData = new FormData();

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    formData.append("id", documentId.toString());
    formData.append("name", documentName);
    formData.append("description", documentDescription);
    formData.append("type", selectedType);
    formData.append("tag", selectedTag);
    formData.append("author", "");
    formData.append("lastModified", new Date().toISOString());
    formData.append("status", selectedStatus);
    formData.append("created", new Date().toISOString());
    formData.append("createdBy", "105");
    formData.append("fileId", fileId);

    axios
      .post(`${process.env.REACT_APP_Alexandria_API}/api/Alexandria/document/insert`, formData, {
        headers: {
          "X-Api-Key": "bmNhbGV4YW5kcmlhYXBpLXN0YWdl",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setShowEditPopup(false);
        setDocumentId(0);
        getAllDocuments();
        setIsLoading(false); 
      })
      .catch((error) => {
        setIsLoading(false); 
        if (error.response.status == 401) {
          navigate("/");
          CommonValues.Logout(navigate);}
      });
  };
  const validate = () => {
    let isValid = true
    setDocumentNameError("");
    setDocumentTagError("");
    setDocumentTypeError("");

    if (documentName.length == 0) {
      setDocumentNameError("Please enter document name.");
      isValid = false
    }
    if (selectedTag == null) {
      setDocumentTagError("Please select tag.");
      isValid = false
    }
    if (selectedType == null) {
      setDocumentTypeError("Please select type.");
      isValid = false
    }

    return isValid
  };
  const onSidebarValueChanged = (value: any) => {
     setShowWideSidebar(value);
  };
  // Helper to get documents by tag
  const getDocumentsByTag = (tag: string) => {
    return documentData.filter((doc: any) => doc.tag === tag);
  };
  // Helper to format date
  const formatDate = (dateString: string) => {
    const utcdate = moment.utc(dateString);
    var localDate = moment(utcdate).local();
    return localDate.format("MM-DD-YYYY HH:mm");
  };
  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar pagename="documents" onSidebarValueChanged={onSidebarValueChanged}/>

      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div
          className={` ${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
           <div>
          <h2 className="fw-bold">Documents</h2>
          <p className="text-muted"></p>
        </div>
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="d-flex align-items-center">
              <span className="p-input-icon-left me-2">
                <i className="fa fa-search grid-search-icon" />
                <InputText
                  type="text"
                  id="txtfirstName"
                  name="globalFilter"
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  value={globalFilter}
                  className="text-14 "
                  placeholder="Search documents"
                  style={{ width:"50vh" }} 
                />
              </span>
              <Button label="Upload a new document" className="alexandria-btn primary-btn" onClick={() => onEditButtonClick("new", null)} />
            </span>
            <span className="ms-auto d-flex align-items-center">
              <div className="toggle-switch-container d-flex align-items-center">
                <span className="toggle-icon me-2">
                  <i className="pi pi-table" style={{ fontSize: '1.2rem', color: viewMode === 'table' ? '#6366f1' : '#6b7280' }} />
                </span>
                <div 
                  className="toggle-switch"
                  onClick={() => setViewMode(viewMode === 'table' ? 'explorer' : 'table')}
                  style={{
                    width: '60px',
                    height: '30px',
                    backgroundColor: viewMode === 'table' ? '#6366f1' : '#e5e7eb',
                    borderRadius: '15px',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '2px'
                  }}
                >
                  <div
                    style={{
                      width: '26px',
                      height: '26px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      transform: viewMode === 'table' ? 'translateX(0)' : 'translateX(30px)',
                      transition: 'transform 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                  />
                </div>
                <span className="toggle-icon ms-2">
                  <i className="pi pi-folder" style={{ fontSize: '1.2rem', color: viewMode === 'explorer' ? '#6366f1' : '#6b7280' }} />
                </span>
              </div>
            </span>
          </div>

          <div className=" ">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
              viewMode === 'table' ? (
                <DataTable
                  value={documentData}
                  globalFilter={globalFilter}
                  stripedRows
                  className="alexandria-table custom-bordered-datatable text-14 "
                  paginator
                  rows={20}
                >
                  <Column
                    header="Sr. No"
                    body={(rowdata, options) => options.rowIndex + 1}
                  />
                  <Column field="name" header="Document Name" sortable></Column>
                  <Column field="type" header="Type" sortable></Column>
                  <Column field="tag" header="Tag" body={tagBodyTemplate} sortable></Column>
                  {/* <Column field="author" header="Author" sortable></Column> */}
                  <Column
                    field="lastModified"
                    header="Last Modified"
                    sortable
                    body={(rowData) => {
                      const utcdate = moment.utc(rowData.lastModified);
                      var localDate = moment(utcdate).local();
                      return <span className="">{localDate.format("MM-DD-YYYY HH:mm")} </span>;
                    }}
                  ></Column>
                  <Column field="status" header="Status" sortable></Column>
                  <Column header="Actions" body={actionBodyTemplate}></Column>
                </DataTable>
              ) : (
                // File Explorer Navigation View
                <div className="file-explorer-view p-4">
                  {!currentFolder ? (
                    <>
                      <h5>Folders</h5>
                      <div className="row folder-grid">
                        {["zoom", "loom", "fireflies"].map((type) => (
                          <div key={type} className="col-md-3 mb-4">
                            <div
                              className="folder-card"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleFolderClick(type)}
                            >
                              <img src={require("../assets/images/folders.png")} alt="Folder" className="folder-img" />
                              <h6 className="folder-title text-capitalize">{type}</h6>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="d-flex align-items-center mb-3">
                        <Button icon="pi pi-arrow-left" className="p-button-text me-2" onClick={handleBackToFolders} />
                        <h5 className="mb-0 text-capitalize">{currentFolder} Documents</h5>
                      </div>
                      <div className="row file-grid">
                        {typeof currentFolder === 'string' && getDocumentsByType(currentFolder).length === 0 ? (
                          <span className="text-muted ms-3">No documents in this folder.</span>
                        ) : null}
                        {typeof currentFolder === 'string' && getDocumentsByType(currentFolder).length > 0 ? (
                          getDocumentsByType(currentFolder).map((doc: any) => (
                            <div key={doc.id} className="col-6 col-sm-4 col-md-3 col-lg-2 mb-2">
                              <div className="file-card d-flex flex-column align-items-center p-1 border rounded" style={{ minHeight: 110 }}>
                                <i className="pi pi-file" style={{ fontSize: '1.5rem', color: '#6366f1' }} />
                                <span className="mt-1 text-center text-truncate w-100" style={{ fontSize: '0.95rem' }} title={doc.name}>{doc.name}</span>
                                <span className="text-muted text-10" style={{ fontSize: '0.8rem', lineHeight: 1 }}>{formatDate(doc.lastModified)}</span>
                                <div className="d-flex justify-content-center mt-1 gap-1">
                                  <Button icon="pi pi-eye" className="p-button-text p-button-sm" style={{ fontSize: '0.9rem' }} onClick={() => onViewButtonClick(doc)} />
                                  <Button icon="pi pi-pencil" className="p-button-text p-button-sm" style={{ fontSize: '0.9rem' }} onClick={() => onEditButtonClick('Existing', doc)} />
                                  <Button icon="pi pi-trash" className="p-button-text p-button-sm" style={{ fontSize: '0.9rem' }} onClick={() => openDeleteDialog(doc.id, doc.name)} />
                                </div>
                              </div>
                            </div>
                          ))
                        ) : null}
                      </div>
                    </>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div></div>
      <Dialog
        header={documentViewType == "new" ? "Create New Document" : "Edit Document"}
        visible={showEditPopup}
        onHide={() => {
          if (!showEditPopup) return;
          setShowEditPopup(false);
          setDocumentId(0);
        }}
        style={{ width: "40vw", minHeight: "auto" }}
        className="text-14 styled-dialog"
        draggable={false}

      >
        {documentByIdLoading ?
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
            <Loader />
          </div>
          :
          <>
            <div className="d-flex align-items-center mb-3 gap-3 mt-2">
              <label className="m-0 text-purple " style={{ width: "150px" }}>
                Document Name <span className="text-danger">*</span>
              </label>
              <InputText
                placeholder="Enter document name"
                className="flex-grow-1 text-16"
                value={documentName}
                onChange={(e) => setDocumentName(e.target.value)}
                invalid={documentNameError.length > 0}
              />
            </div>

            <div className="d-flex align-items-start mb-3 gap-3">
              <label className="m-0 text-purple " style={{ width: "150px", paddingTop: "0.5rem" }}>
                Description
              </label>
              <InputTextarea
                rows={3}
                placeholder="Add a short description"
                className="flex-grow-1"
                value={documentDescription}
                onChange={(e) => setDocumentDescription(e.target.value)}
              />
            </div>

            <div className="d-flex align-items-start mb-3 gap-3">
              <label className="m-0 text-purple" style={{ width: "150px", paddingTop: "0.5rem" }}>
                Replace File <span className="text-danger">*</span>
              </label>
              <div className="flex-grow-1 text-center border rounded">
                <FileUpload
                  name="pdf"
                  customUpload
                  auto
                  onSelect={(e) => {
                    if (e.files && e.files.length > 0) {
                      setSelectedFile(e.files[0]);  // Save the first file selected
                    }
                  }}
                  onRemove={() => setSelectedFile(null)}
                  chooseLabel="Select Document"
                  emptyTemplate={<p className="m-0">Drop document here</p>}
                />
              </div>
            </div>

            <div className="d-flex align-items-center mb-4 gap-3">
              <label className="m-0 text-purple" style={{ width: "150px" }}>
                Tags <span className="text-danger">*</span>
              </label>
              <Dropdown
                value={selectedTag}
                options={tagOptions}
                onChange={(e) => setSelectedTag(e.value)}
                placeholder="Please select tag"
                className="flex-grow-1"
                invalid={documentTagError.length > 0}
              />
            </div>

            <div className="d-flex align-items-center mb-4 gap-3">
              <label className="m-0 text-purple" style={{ width: "150px" }}>
                Type <span className="text-danger">*</span>
              </label>
              <Dropdown
                value={selectedType}
                options={typeOptions}
                onChange={(e) => setSelectedType(e.value)}
                placeholder="Please select type"
                className="flex-grow-1"
                invalid={documentTypeError.length > 0}
              />
            </div>
              {documentViewType !== "new" && (
                <div className="d-flex align-items-center mb-4 gap-3">
                  <label className="m-0 text-purple " style={{ width: "150px" }}>
                   Status <span className="text-danger">*</span>
                  </label>
               <Dropdown
                  value={selectedStatus}
                  options={statusOptions}
                  onChange={(e) => setSelectedStatus(e.value)}
                  placeholder="Please update status"
                  className="flex-grow-1"
                  invalid={documentStatusError.length > 0}
                />
              </div>
             )}
            <div className="d-flex justify-content-end gap-2">
              <Button label="Cancel" className="alexandria-btn secondary-btn" onClick={() => setShowEditPopup(false)} />
              <Button className="alexandria-btn primary-btn" onClick={onSaveButtonClick} disabled={isLoading}>
              {isLoading ? <><div className="loader" /> Saving...</> : (documentViewType === "new" ? "Save" : "Update")}
              </Button>
            </div>
          </>
        }
      </Dialog>
      <Dialog
        header="Preview Document"
        visible={showViewPopup}
        onHide={() => setShowViewPopup(false)}
        style={{width: "50vw",minHeight: previewLoading || (selectedType === "other" && selectedFile)? "80vh": "60vh",}}
        className="text-14 styled-dialog"
        draggable={false}>
     {previewLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
      <Loader />
      </div>
       ) : selectedType === "other" ? (
      selectedFile ? (
         <iframe
            src={selectedFile as string}
            title="Uploaded Document"
            width="100%"
            height="600px"
            style={{ border: "none" }}
         />
      ) : (<p>No document available for preview.</p>)
      ) : (
      <TabView>
        <TabPanel header="Call Summary">
          <div className="row gy-3">
            <div className="col-md-6">
              <div className="bg-light p-2 rounded mb-2">
                <h6 className="link-title">Caller Name</h6>
                <div className="text-12">{callerName}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-light p-2 rounded mb-2">
                <h6 className="link-title">Call Duration</h6>
                <div className="text-12">{callDuration}s</div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="bg-light p-2 rounded">
                <h6 className="link-title">Summary</h6>
                <div className="text-12">{callSummary}</div>
               </div>
            </div>
          </div>
        </TabPanel>
      </TabView>
    )}
  </Dialog>
  <Dialog
     header="Confirm Delete"
     visible={deleteDialogVisible}
     style={{ width: '375px' }}
     modal
     onHide={cancelDelete}
     className="styled-dialog"
     footer={
             <div className="d-flex justify-content-center">
              <Button label="Cancel" icon="pi pi-times" onClick={cancelDelete} className="alexandria-btn secondary-btn me-4" />
              <Button label="Delete" icon="pi pi-trash" onClick={confirmDelete} className="p-button curved-button primary-btn" />
             </div>
           }>
            <p>
              Are you sure you want to delete 
              <strong>{" "}{documentNameToDelete}</strong> ?
           </p>
   </Dialog>
  </div>
  );
}
